<template>
  <div class="drawer-wrapper">
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="AddFundingTypeFlag" size="50%"
               :before-close="AddNone" direction="rtl">

      <div class="demo-drawer__content">
        <el-form :model="addFrom" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="选择项目" :label-width="formLabelWidth" prop="project_name">
                <el-autocomplete
                  v-model="addFrom.project_name"
                  style="width: 90%;"
                  :disabled="title == '编辑'"
                  :fetch-suggestions="querySearch"
                  clearable
                  placeholder="请选择项目（可输入关键字搜索）"
                  @select="handleSelect"
                >
                <template slot-scope="{ item }">
                  <div>{{ item.name }}</div>
                </template>
              </el-autocomplete>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="评级" prop="level" :label-width="formLabelWidth">
                <el-select v-model="addFrom.level" placeholder="请选择评级" clearable style="width: 90%;">
                  <el-option label="S" :value="1"></el-option>
                  <el-option label="A+" :value="2"></el-option>
                  <el-option label="A" :value="3"></el-option>
                  <el-option label="B" :value="4"></el-option>
                  <el-option label="C" :value="5"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb40">
              <el-form-item label="上线时间" prop="time" :label-width="formLabelWidth">
                <el-row :gutter="36">
                  <el-col :xs="36" :sm="36" :md="36" :lg="36" :xl="36" class="mb20">
                    <el-form-item label="IAP" prop="iap_time" :label-width="formLabelWidthChild">
                      <el-date-picker
                        v-model="addFrom.iap_time"
                        style="width: 90%;"
                        type="datetime"
                        placeholder="请选择 IAP 上线时间"
                        align="left"
                        clearable
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="36" :sm="36" :md="36" :lg="36" :xl="36" class="mb20">
                    <el-form-item label="IAA" prop="iaa_time" :label-width="formLabelWidthChild">
                      <el-date-picker
                        v-model="addFrom.iaa_time"
                        style="width: 90%;"
                        type="datetime"
                        placeholder="请选择 IAA 上线时间"
                        align="left"
                        clearable
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="36" :sm="36" :md="36" :lg="36" :xl="36">
                    <el-form-item label="星图" prop="starmap_time" :label-width="formLabelWidthChild">
                      <el-date-picker
                        v-model="addFrom.starmap_time"
                        style="width: 90%;"
                        type="datetime"
                        placeholder="请选择 星图 上线时间"
                        align="left"
                        clearable
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="承制主体" prop="subject_cz_name" :label-width="formLabelWidth">
                <el-input v-model="currentItem.subject_cz_name" disabled placeholder="-" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="合作类型" prop="cooperate_type_text" :label-width="formLabelWidth">
                <el-input v-model="currentItem.cooperate_type_text" disabled placeholder="-" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="推荐卡点" prop="stuck_point" :label-width="formLabelWidth">
                <el-input v-model="addFrom.stuck_point" placeholder="请输入推荐卡点" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="网盘链接" prop="cloud_url" :label-width="formLabelWidth">
                <el-input v-model="addFrom.cloud_url" placeholder="请输入网盘链接" clearable style="width: 90%;">
                  <template slot="append"><span style="cursor: pointer" @click="copy()">复制</span></template>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="其他文件" prop="project_file" :label-width="formLabelWidth" style="width: 90%;">
                <el-upload
                    class="upload-demo"
                    action
                    :http-request="(file) => httpRequest(file)"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    :multiple="false"
                    :limit="myLimit"
                    :on-exceed="handleExceed"
                    :before-upload="beforeAvatarUpload"
                    accept=".pdf,.docx,.doc,.xlsx,.xls,.txt"
                    :file-list="fileList">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传Pdf，Word，Excel，Txt文件，且不超过20MB</div>
                </el-upload>
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>

    </el-drawer>
  </div>
</template>

<script>
import {MoneyManagementAPI} from '@/api/MoneyManagement/MoneyManagement';
import {processErrors} from "@/utils/errorHandler";

export default {
  props: ['AddFundingTypeFlag', "editID"],
  components: {},
  data() {
    // 表单校验规则-下拉选择项目--只有下拉选择的项目才算，手动输入不算
    var validateItem = (rule, value, callback) => {
      if(this.title == '编辑'){
        callback();
      }
      setTimeout(() => {
        if (Object.keys(this.currentItem).length === 0) {
          return callback(new Error('请在下拉列表中选择项目'));
        }else{
          callback();
        }
      },500);
    };
    // 表单校验规则-时间--三个时间中输入至少一个
    var validateTime = (rule, value, callback) => {
      const {iap_time, iaa_time, starmap_time} = this.addFrom;
      if (iap_time || iaa_time || starmap_time) {
        callback();
      }else{
        return callback(new Error('请在上述三个时间中 至少输入一个'));
      }
    };

    return {
      title: "",
      formLabelWidth: "140px",
      formLabelWidthChild: "40px",
      currentItem:{}, // 当前选择的项目
      addFrom: {
        project_id: '',
        project_name: '',
        level:'',
        iap_time:'',
        iaa_time:'',
        starmap_time:'',
        stuck_point:'',
        cloud_url: '',
        project_file: [],
      }, 
      // 表单规则
      rules: {
        project_name: [
          {required: true, trigger: 'blur', validator: validateItem,},
        ],
        time: [
          {required: true, trigger: 'blur', validator: validateTime,},
        ],
      },
      // 项目下拉列表
      restaurants: [],
      // 时间选择器-快捷选项
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '明天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周后',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      fileList: [],
      api: MoneyManagementAPI(),
      format:'yyyy-MM-dd HH-mm-ss',
      myLimit: 5, // 文件上传数量限制个数
    };
  },
  watch:{
    AddFundingTypeFlag(newValue, oldValue){
      if(newValue){
        if (this.editID != "" && this.editID) {
          this.title = "编辑"
          this.api.getScheduleInfo({id: this.editID}).then(res => {
            if (res.code == 0) {
              // 更新表单数据
              this.updateObject(res.data,this.addFrom)
              // 获取项目下拉列表
              this.initProjectName(res.data.project_id)
              // 获取上传文件列表
              if(res.data.project_file && res.data.project_file.length>0){
                this.fileList = res.data.project_file.map((item,index) => {
                  return {
                    index,
                    status: 'success',
                    ...item
                  }
                })
              }
            } else {
              processErrors(res);
            }
          })
        }else{
          this.title = "新增"
          this.initProjectName('')
        }
      }
    },
  },
  mounted() {

  },
  methods: {
    /**取消 */
    AddNone() {
      this.initData()
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },
    /**用户点击提交 */
    addPush() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          // 规范文件上传的格式
          if (this.fileList.length > 0) {
            let queryFiles = []
            this.fileList.forEach(item => {
              queryFiles.push({
                name: item.name,
                url: item.url,
              })
            })
            this.addFrom.project_file = queryFiles;
          }else{
            this.addFrom.project_file = [];
          }
          // 规范指定参数不能为空串
          let checkList=['iaa_time', 'iap_time', 'starmap_time', 'level',]
          for (let item in this.addFrom){
            if(checkList.includes(item) && !this.addFrom[item]){
              // 校验，如果没值或空串，返回null
              this.addFrom[item] = null
            }
          }
          // 删除多余参数
          delete this.addFrom.project_name

          if (this.title == '编辑') {
            // 添加排期id
            this.addFrom.id = this.editID
          }else{
            // 添加项目id
            this.addFrom.project_id = this.currentItem.id
          }

          this.api.getScheduleEdit(this.addFrom).then(res => {
            if (res.code == 0) {
              this.$message({
                message: this.title + '成功',
                type: 'success'
              });
              this.$emit('AddOk');
            } else {
              processErrors(res);
            }
            this.initData()
          })
        } else {
          return false;
        }
      });

    },
    querySearch(queryString, cb) {
      if(!queryString || queryString != this.addFrom.project_name || this.currentItem?.name != queryString){
        this.currentItem = {}
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      }else{
        cb(this.restaurants);
      }
    },
    createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.name.indexOf(queryString) === 0);
        };
      },
    handleSelect(item) {
      this.currentItem = item
      this.addFrom.project_name = item.name
    },
    /**移除 */
    handleRemove(file, fileList) {
      if(file && file.status == 'success'){
        // 只用判断成功状态的数据
        const i = this.fileList.findIndex(item=>item.index == file.index);
        i !=-1 ? this.fileList.splice(i, 1) : ''
      }
    },
    /**预览 */
    handlePreview(e) {
      let url = this.fileList[e.index].url_full
      window.open(url, '_blank'); // '_blank' 表示在新标签页中打开
    },
    handleExceed(files,fileList) {
      this.$message.warning(`当前限制选择 ${this.myLimit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },

    beforeRemove(file, fileList) {
      if(file && file.status == 'success'){
        // 只有成功状态的数据才用提示卡他
        return this.$confirm(`确定移除 ${file.name}？`);
      }
    },
    httpRequest(file) {
      let fileUpload = new FormData();
      fileUpload.append("file", file.file);
      this.uploadFile(fileUpload,file.file);
    },

    uploadFile(fileUpload,file) {
      this.api.getScheduleUpload(fileUpload).then((res) => {
        if (res.code == 0) {
          // 上传成功后添加到列表
          this.fileList.push({
            name: file.name,
            index: this.fileList.length,
            ...res.data,
            url: res.data.url,
            url_full: res.data.url_full,
            status: 'success', //手动添加文件状态
          })
        } else {
          processErrors(res);
        }
      });
    },
    /**上传之前大小 */
    beforeAvatarUpload(file){
      const isSize0 = file.size != 0;
      if (!isSize0) {
        this.$message.error('上传文件大小不能为 0 !');
      }
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 20MB!');
      }
      return isSize0 && isLt2M;
    },
    copy(){
      if (this.addFrom.cloud_url) {
        this.$emit('addput',this.addFrom.cloud_url)
      }else{
        this.$message.warning('当前没有链接可复制');
      }
    },
    /**
     * 把a中的数据更新到b中，并不新增b的属性
     * a,b都得传对象
     */
    updateObject(a, b) {
      Object.keys(b).forEach(key => {
        if (a.hasOwnProperty(key)) {
          b[key] = a[key];
        }
      });
    },
    /**获取项目下拉列表
     * @param {*} project_id 编辑-传此id，接口会返回包含此项目的列表，否则返回除已排期的所有项目列表
     */
    initProjectName(project_id){
      this.api.getScheduleProjectSelect({project_id}).then(res => {
        if (res.code == 0) {
          this.restaurants = res.data
          if(project_id){
            this.currentItem = res.data.find(item => item.id == project_id)
            this.addFrom.project_name = this.currentItem.name
          }
        } else {
          processErrors(res);
        }
      })
    },
    /**初始化表单数据 */
    initData(){
      this.addFrom = {
        project_id: '',
        project_name: '',
        level:'',
        iap_time:'',
        iaa_time:'',
        starmap_time:'',
        stuck_point:'',
        cloud_url: '',
        project_file: [],
      }
      this.fileList = [] 
      this.title = ""
      this.currentItem = {}
    }
    
  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  margin-top: 20px;
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px; /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}

.mb40{
  margin-bottom: 40px;
}
</style>